/* eslint-disable max-len */
import { SvgIcon } from '@mui/material';
import { CustomSvgIcon } from '@tassat/ui-definitions';
import * as React from 'react';

export default function Edit(props: CustomSvgIcon) {
    const {
        id,
        className,
        iconColor,
        onClick
    } = props;

    return (
        <SvgIcon
            className={className || ''}
            id={id || ''}
            onClick={onClick}
        >
            <svg
                preserveAspectRatio='xMidYMid meet'
                version='1.0'
                viewBox='0 0 225.000000 225.000000'
                xmlns='http://www.w3.org/2000/svg'
            >
                <g
                    fill={iconColor || '#000000'}
                    stroke='none'
                    transform='translate(0.000000,225.000000) scale(0.100000,-0.100000)'
                >
                    <path d='M1690 2217 c-26 -7 -62 -23 -80 -34 -19 -12 -315 -302 -656 -645 -600 -601 -708 -718 -764 -829 -21 -41 -166 -666 -157 -676 4 -3 140 25 304 62 l298 68 140 86 140 86 628 625 c692 689 681 676 681 794 -1 99 -26 143 -172 289 -73 74 -146 138 -172 152 -58 29 -132 38 -190 22z m123 -138 c31 -16 246 -229 263 -261 17 -32 18 -76 4 -114 -12 -30 -207 -234 -224 -234 -14 0 -386 372 -386 385 0 16 191 202 225 219 35 19 87 21 118 5z m-495 -1157 c-282 -281 -469 -460 -514 -492 l-70 -49 -177 177 c-97 98 -177 181 -177 186 0 22 98 126 524 554 l461 462 197 -197 198 -198 -442 -443z m-708 -614 c0 -14 -385 -106 -397 -95 -5 5 67 349 83 396 3 10 57 -37 159 -139 85 -85 155 -158 155 -162z' />
                </g>
            </svg>
        </SvgIcon>
    );
}